import { Link } from "react-router-dom";
import { formatPrice } from "../lib/api";
import { usePromo, applyDiscount } from "./PromoBanner";

export const ProductCard = ({ product, index = 0 }) => {
  const promo = usePromo();
  const hasSale = promo?.active && promo.discount_pct > 0;
  const isBogo = promo?.active && promo.type === "bogo";
  const priced = hasSale ? applyDiscount(product.price_inr, promo.discount_pct) : null;
  return (
    <Link
      data-testid={`product-card-${product.id}`}
      to={`/product/${product.id}`}
      className="group block image-zoom-parent"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#1F1A17]">
        <img
          src={product.image_url}
          alt={product.name}
          className="image-zoom w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-4 left-4 flex flex-col gap-2 items-start">
          {product.is_best_seller && (
            <span
              data-testid={`badge-best-${product.id}`}
              className="bg-[#D4AF37] text-[#15110F] px-3 py-1 text-[10px] tracking-overline uppercase font-bold"
            >
              Best Seller
            </span>
          )}
          {isBogo && (
            <span
              data-testid={`badge-bogo-${product.id}`}
              className="bg-[#15110F]/85 backdrop-blur border border-[#D4AF37] text-[#D4AF37] px-3 py-1 text-[10px] tracking-overline uppercase font-bold"
            >
              Buy 1 Get 1 Free
            </span>
          )}
        </div>
        <span className="absolute bottom-4 right-4 text-[10px] tracking-overline uppercase text-[#D4AF37] bg-[#15110F]/80 backdrop-blur px-3 py-1 font-bold">
          № {String(index + 1).padStart(3, "0")}
        </span>
      </div>

      <div className="mt-5 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3
            data-testid={`product-name-${product.id}`}
            className="font-serif-display text-2xl leading-tight text-[#F4EAD9] group-hover:text-[#D4AF37] transition-colors"
          >
            {product.name}
          </h3>
          <p
            data-testid={`product-notes-${product.id}`}
            className="mt-1 text-sm text-[#D4AF37] truncate"
          >
            {product.notes}
          </p>
          <div className="mt-3 flex flex-wrap gap-x-3 gap-y-1">
            {product.categories.slice(0, 3).map((c) => (
              <span
                key={c}
                className="text-[10px] tracking-overline uppercase text-[#B0A496] font-bold"
              >
                {c}
              </span>
            ))}
          </div>
        </div>
        <p
          data-testid={`product-price-${product.id}`}
          className="shrink-0 font-sans-body text-base font-medium text-[#F4EAD9] tabular-nums text-right"
        >
          {hasSale ? (
            <>
              <span className="block text-[#D4AF37] font-bold">₹{priced.formattedDiscounted}</span>
              <span className="block text-xs text-[#B0A496] line-through mt-0.5">
                {formatPrice(product.price_inr)}
              </span>
            </>
          ) : (
            formatPrice(product.price_inr)
          )}
        </p>
      </div>
    </Link>
  );
};

export default ProductCard;
